import React from 'react'
import PropTypes from 'prop-types'

import { Motion, Wrapper } from 'Components/UI'
import { Column, Flex } from 'Components/UI/_Legacy'

import DataBlock from './DataBlock'
import ImageBlock from './ImageBlock'
import {
  PathCornerBL,
  PathCornerBR,
  PathCornerTL,
  PathCornerTR,
  PathHorizontal,
} from './paths'
import { Block, Container, Content, HorizontalDelimiterHolder } from './styles'

const horizontalLine = mirror => (
  <Flex width="calc(50% + 16px)">
    {!mirror ? <PathCornerTL /> : <PathCornerBL />}

    <Flex overflow="hidden">
      <Column>
        <PathHorizontal />
      </Column>
    </Flex>
    {!mirror ? <PathCornerBR /> : <PathCornerTR />}
  </Flex>
)

const horizontalDelimiter = (index, odd) => (
  <>
    {index < 3 ? (
      <HorizontalDelimiterHolder>
        {odd ? horizontalLine(false) : horizontalLine(true)}
      </HorizontalDelimiterHolder>
    ) : null}
  </>
)

function RoadMap({ data, rendered }) {
  return (
    <Container>
      {data.map((step, index) => {
        const odd = !(index % 2)

        return (
          <Content key={step.id}>
            <Wrapper>
              <Motion>
                <Block
                  flexDirection={[
                    'column',
                    'column',
                    odd ? 'row' : 'row-reverse',
                  ]}
                  zIndex={index + 1}
                >
                  <Flex
                    ml={!odd ? [0, 0, '32px'] : 0}
                    pr={odd ? '15px' : 0}
                    width={[1, 1, 1 / 2]}
                  >
                    <DataBlock index={index} odd={odd} step={step} />
                  </Flex>

                  <Flex
                    justifyContent={['center', 'center', 'flex-start']}
                    width={['100%', '100%', '50%']}
                  >
                    <ImageBlock index={index} rendered={rendered} />
                  </Flex>
                </Block>
              </Motion>
            </Wrapper>

            {horizontalDelimiter(index, odd)}
          </Content>
        )
      })}
    </Container>
  )
}

RoadMap.defaultProps = {
  data: [],
}

RoadMap.propTypes = {
  data: PropTypes.array,
  rendered: PropTypes.bool.isRequired,
}

export default RoadMap
